import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { AppContext } from '../../services/AppContext';
import { Frame, useMotionValue, useTransform } from 'framer';

import styles from './Playbar.module.css';

export default class Playbar extends React.Component {
	static contextType = AppContext;

	render() {
		const {
			theme,
			onChange,
			time,
			isPlaying,
			onPlayClick,
			percent,
			deviceWidth,
		} = this.props;
		const { slider } = theme;
		const { background, accentColor, color, knob } = slider;
		const { locale } = this.context;
		return (
			<div className={styles['playbar']} style={{ background }}>
				<div>
					<div
						onClick={onPlayClick}
						className={`${
							styles[`icon-${isPlaying ? 'pause' : 'play'}`]
						}`}
					>
						<button
							title={
								isPlaying
									? locale['BUTTON_TITLE_PAUSE']
									: locale['BUTTON_TITLE_PLAY']
							}
							style={{ background: color }}
						/>
					</div>
				</div>
				<div>
					<Slider
						min={0}
						max={100}
						knob={knob}
						percent={percent | 0}
						background={accentColor}
						onChange={onChange}
						width={deviceWidth < 769 ? 200 : 170}
					/>
				</div>
				<div>
					<small style={{ color }}>
						{toHHMMSS(time ? time / 1000 : 0)}
					</small>
				</div>
			</div>
		);
	}
}

Playbar.propTypes = {
	theme: PropTypes.object,
	onChange: PropTypes.func,
	time: PropTypes.any,
	isPlaying: PropTypes.bool,
	onPlayClick: PropTypes.func.isRequired,
	percent: PropTypes.number,
	deviceWidth: PropTypes.number,
};

function Slider({ width, background, min, max, percent, onChange, knob }) {
	width = width || 200;
	background = background || '#000000';

	const progress = (percent * width) / 100;

	let position = useMotionValue(progress);
	const newPercent = useTransform(position, [0, width], [min, max]);

	useEffect(() => {
		position.set(progress);
	}, [progress]);

	let knobSize = knob.size || 20;
	if (typeof knobSize === 'string') {
		knobSize = JSON.parse(knobSize);
	}

	let offset = -1 * (knobSize / 2);
	return (
		<Frame
			name={'Rail'}
			width={width}
			height={6}
			center
			background={'rgba(0,0,0,.2)'}
			radius={3}
		>
			<Frame
				name={'Fill'}
				width={position}
				height={6}
				radius={3}
				background={background}
			/>
			<Frame
				name={'Knob'}
				size={knobSize}
				center={'y'}
				radius={'50%'}
				background={knob.color}
				shadow={'0 0px 0px 0px #242424'}
				left={offset}
				drag={'x'}
				x={position}
				dragConstraints={{ left: 0, right: width }}
				dragElastic={0}
				dragMomentum={false}
				onDrag={() => {
					if (onChange) onChange(newPercent.get());
				}}
			/>
		</Frame>
	);
}

Slider.propTypes = {
	width: PropTypes.number.isRequired,
	min: PropTypes.number.isRequired,
	max: PropTypes.number.isRequired,
	percent: PropTypes.number,
	onChange: PropTypes.func.isRequired,
	knob: PropTypes.object.isRequired,
	background: PropTypes.string,
	position: PropTypes.object,
};

function toHHMMSS(secs) {
	console.log(`Secs: ${secs}`);
	if (secs === 0 || secs === null || secs === undefined) {
		return '00:00';
	}
	var sec_num = parseInt(secs, 10);
	var hours = Math.floor(sec_num / 3600);
	var minutes = Math.floor(sec_num / 60) % 60;
	var seconds = sec_num % 60;

	return [hours, minutes, seconds]
		.map((v) => (v < 10 ? '0' + v : v))
		.filter((v, i) => v !== '00' || i > 0)
		.join(':');
}
